/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomerTypeButton extends Component {

  render() {
    const { name } = this.props;

    return (
      <div onClick={this.props.onClick} role="cust" className={`cust-btn cust` + (this.props.active ? ` selected` : ``)}>
          { name }
      </div>
    );
  }
}

export default CustomerTypeButton;



// WEBPACK FOOTER //
// ./src/components/CustomerTypeBar/CustomerTypeButton.jsx